import { reportFolioServices } from '../../../../../../service/reportFolio'
import { httpFetch } from '../../../../../../utils/crud'
import { getYear } from 'date-fns'
import { Item } from '../../../../../../utils/types/generals'
import {
  areaServices,
  departmentService,
  storeServices,
  divisionService,
  userServiceFetch,
} from './constants/states'
import { Roles } from '../../../../../../utils/enums'
import { getUserRole } from '../../../../../../service/auth'
import { userTypeServiceFetch } from '../../../../../../utils/constants/callService'
import { CancelFoliosInterface, DeleteFoliosInterface, reassignFoliosInterface } from '../../../../../../service/reportFolio/body'

const getData = async (data?: { query?: string }) => {
  const reportFolioService = reportFolioServices(httpFetch)
  const reportFolioList = await reportFolioService.reportFolioList({
    query: data?.query ?? 'size=20&page=1',
  })

  if (!!reportFolioList.errors) {
    return { rows: [] }
  }

  let years: Item[] = []

  const rows = reportFolioList?.items?.map((item) => {
    const year = getYear(new Date(item.createTime)).toString()

    if (!years.some((el) => el?.value == year)) {
      years = [
        ...years,
        {
          label: year,
          value: year,
        },
      ]
    }
    const store = {
      name: item?.storeName ?? '',
      address: item?.storeAddress ?? '',
      storeId: item?.storeId,
      storeKeyCode: item?.storeKeyCode
    }
    const area = item?.areaName ?? ''
    const department = item?.departmentName ?? ''
    const createByUser = item?.creatorFullName ?? ''

    return {
      priorityHeader: item?.priorityName,
      unitHeader: `${area ? `${area} / ` : ''}${department ? `${department} / ` : ''
        }${store?.name ? `${store?.name} - ` : ''}${store?.address ? `${store?.address} - ` : ''
        }${createByUser ?? ''}`,
      statusHeader: item?.statusDescription,
      id: item?.id,
      type: item?.type,
      existSolutionCaseMgDpto: item.existSolutionCaseMgDpto,
      priorityId: item?.priorityId,
      existAnyQuote: item?.existAnyQuote,
      idsUserManagersDpto: item?.idsUserManagersDpto,
      foliosAmount: item?.folio,
      priority: item?.priorityName,
      creatorFullName: item?.creatorFullName ?? "",
      comment: item.totalComments,
      reference: item.parent?.folio ?? null,
      instruction: item.commentsInstruction.length > 0,
      unit: JSON.stringify({
        title: area,
        department: department,
        content: `${store?.name ?? ''}${!!store?.name && !!store?.storeKeyCode ? ' - ' : ''
          }${store?.storeKeyCode ?? ''}`,
        user: `${createByUser}`,
        id: store?.storeId
      }),
      departmentId: item?.departmentId,
      requestDate: {
        requestDate: item?.createTime,
        solveDate: item?.solutionDate
      },
      timeElapsed: item?.solutionTime,
      status: {
        value: item?.statusId,
        reportUrl: item?.reportUrl,
      },
      usersAssigned: item?.usersAssigned,
      canResponse: item?.canResponse,
      canReassign: item?.canReassign,
      creatorId: item.creatorId,
      typeAssign: item.typeAssign,
      statusAttentionId: item.statusAttentionId
    }
  })

  return {
    rows,
    years,
    totalPages: reportFolioList?.totalPages ?? 1,
    totalItems: reportFolioList?.totalItems ?? 0,
  }
}

interface FolioIds {
  id: number;
  departmentId: number;
}

/* const getAllsIds = async (queryString?:string): Promise<FolioIds[]> => {
  const reportFolioService = reportFolioServices(httpFetch);

  const initialResponse = await reportFolioService.reportFolioList({
    query: `size=1&page=1${queryString ? `&${queryString}`:''}`
  });

  if (!!initialResponse.errors) return [];

  const fullResponse = await reportFolioService.reportFolioList({
    query: `size=${initialResponse.totalItems}&page=1${queryString ? `&${queryString}`:''}`
  });

  if (!!fullResponse.errors) return [];

  return fullResponse.items.map(item => ({
    id: item.id,
    departmentId: item.departmentId
  }));
}; */

type DepartmentIdsInterface = {
  all: boolean,
  not_department_ids: number[]
  department_ids: number[]
}

const getAllDepartmentsWithFoliosId = async (params: DepartmentIdsInterface) => {
  const reportFolioService = reportFolioServices(httpFetch);

  let query = '';

  if (params.all) {
    // Si all es true, incluimos all=true y not_department_ids
    query = `all=true&not_department_ids=${params.not_department_ids.join(',')}`;
  } else {
    // Si all es false, solo incluimos department_ids
    query = `all=false&department_selected_ids=${params.department_ids.join(',')}`;
  }
  const fullResponse = await reportFolioService.getDepartmentsWithFoliosIds({
    query: query
  });

  return fullResponse;
};

const getStore = async () => {
  const role = getUserRole()
  let allStores

  switch (role) {
    case Roles.ADMIN:
      allStores = await storeServices.getAllStores()
      break
    default:
      allStores = await storeServices.getStoresFilter()
      break
  }

  if (!!allStores?.errors) return []

  return allStores?.map((item) => ({
    label: `${item.keyCode} - ${item.name}`,
    value: item.id,
  })) as Item[]
}

const getArea = async () => {
  const allAreas = await areaServices.getAllAreas()

  if (!!allAreas?.errors) return []

  return allAreas.map((item) => ({
    label: item.name,
    value: item.id,
  })) as Item[]
}

const getDivisions = async () => {
  const role = getUserRole()
  let allDivisions

  switch (role) {
    case Roles.ADMIN:
      allDivisions = await divisionService.getAllDivision()
      break
    default:
      allDivisions = await divisionService.getDivisionsFilter()
      break
  }

  if (!!allDivisions?.errors) return []

  return allDivisions.map((item) => ({
    label: item.description ?? item.name,
    value: item.id,
  })) as Item[]
}

const getDepartments = async () => {
  const allDepartments = await departmentService.getAllDepartments()

  if (!!allDepartments?.errors) return []

  return allDepartments.map((item) => ({
    label: item.name,
    value: item.id,
    areaId: item.areaId,
  })) as Item[]
}

const getUsers = async () => {
  const role = getUserRole()
  let allUsers

  switch (role) {
    case Roles.AGENT:
    case Roles.PARTNER:
    case Roles.SUPPORT:
    case Roles.STORE:
      allUsers = null
      break
    default:
      allUsers = await userServiceFetch.usersByStatus({ addUserLogged: true })
      break
  }

  if (!!allUsers?.errors) return []

  return allUsers?.map((item) => ({
    label: `${item.firstName} - ${item.lastName}`,
    value: item.id,
  })) as Item[]
}

const getUserTypes = async () => {
  const role = getUserRole()
  let allUsersType

  switch (role) {
    case Roles.SUPERVISOR:
    case Roles.GERENT:
    case Roles.SUPPORT:
      allUsersType = await userTypeServiceFetch.userTypeListFilter()
      break
    case Roles.AGENT:
    case Roles.STORE:
    case Roles.PARTNER:
    case Roles.AUDIT:
      allUsersType = null
      break
    default:
      allUsersType = await userTypeServiceFetch.userTypeList()
      break
  }

  if (!!allUsersType?.errors) return []

  return (allUsersType?.map((item: any) => ({
    label: item.name,
    value: item.id,
  })) as Item[])
}

const cancelFolios = async (body: CancelFoliosInterface,query?:string) => {
  const reportFolioService = reportFolioServices(httpFetch)
  const response = await reportFolioService.newCancelFolio(body,query);
  return response;
}

const reassignFolios = async (body: reassignFoliosInterface,query?:string) => {
  const reportFolioService = reportFolioServices(httpFetch)
  const response = await reportFolioService.reassignFolio(body,query);
  return response;
}

const deleteFolios = async (body: DeleteFoliosInterface,query?:string) => {
  const reportFolioService = reportFolioServices(httpFetch)
  const response = await reportFolioService.newDeleteFolio(body,query);
  return response;
}

const generateInform = async (uuid?:string,query?:string) => {
  const reportFolioService = reportFolioServices(httpFetch)
  const response = await reportFolioService.generateSummary(uuid,query);
  return response;
}


export {
  getData,
  getStore,
  getArea,
  getDepartments,
  getUsers,
  getUserTypes,
  getDivisions,
  cancelFolios,
  deleteFolios,
  getAllDepartmentsWithFoliosId,
  reassignFolios,
  generateInform
}
